/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface PaymentData
 */
export interface PaymentData {
    /**
     * 
     * @type {string}
     * @memberof PaymentData
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentData
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentData
     */
    amount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PaymentData
     */
    chargedPrice?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof PaymentData
     */
    completedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentData
     */
    receivedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentData
     */
    cancelledAmount?: number;
}

/**
 * Check if a given object implements the PaymentData interface.
 */
export function instanceOfPaymentData(value: object): value is PaymentData {
    return true;
}

export function PaymentDataFromJSON(json: any): PaymentData {
    return PaymentDataFromJSONTyped(json, false);
}

export function PaymentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentData {
    if (json == null) {
        return json;
    }
    return {
        
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'chargedPrice': json['chargedPrice'] == null ? undefined : MoneyOutputFromJSON(json['chargedPrice']),
        'completedAmount': json['completedAmount'] == null ? undefined : json['completedAmount'],
        'receivedAmount': json['receivedAmount'] == null ? undefined : json['receivedAmount'],
        'cancelledAmount': json['cancelledAmount'] == null ? undefined : json['cancelledAmount'],
    };
}

export function PaymentDataToJSON(json: any): PaymentData {
    return PaymentDataToJSONTyped(json, false);
}

export function PaymentDataToJSONTyped(value?: PaymentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remoteId': value['remoteId'],
        'name': value['name'],
        'amount': value['amount'],
        'chargedPrice': MoneyOutputToJSON(value['chargedPrice']),
        'completedAmount': value['completedAmount'],
        'receivedAmount': value['receivedAmount'],
        'cancelledAmount': value['cancelledAmount'],
    };
}

